import { render, staticRenderFns } from "./ChooseSingleDealer.vue?vue&type=template&id=5f5f3177&scoped=true"
import script from "./ChooseSingleDealer.vue?vue&type=script&lang=js"
export * from "./ChooseSingleDealer.vue?vue&type=script&lang=js"
import style0 from "./ChooseSingleDealer.vue?vue&type=style&index=0&id=5f5f3177&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5f3177",
  null
  
)

export default component.exports